export const useStyles = (theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
  content: {
    width: "50%",
    marginRight: 5,
  },
});
